export const extractArrayMessage = (message={}) => {
  const keys = Object.keys(message);
  let msgStr = '';
  if (keys.length) {
    keys.map((key) => {
      msgStr +=
        key === 'non_field_errors'
          ? message[key]
          : `${key}: ${message[key]} \n`;
    });
  }
  return msgStr;
};

export const ApiFailMessageFilter = (error = {}) => {
  const message = {};

  const {response} = error;
  if (response) {
    const {data = {}, config = {}} = response;
    message.status = response.status || data.http_status_code;

    if (data.extra_info) {
      message.extra_info = data.extra_info;
    }

    if (data.message) {
      message.message =
        typeof data.message === 'object'
          ? extractArrayMessage(data.message)
          : data.message || "Something went wrong!, Please contact support.";
    }

    message.url = config.url;
    message.errorcode = data.errorcode;
    message.data = data.data;

    if(!message.message && data.error && typeof data.error === 'string') {
      message.message = data.error || "Something went wrong!, Please contact support."
    }
  }
  return message;
};
